const AccessAuthorization = "/access-authorization";
const ShiftRecords = "/shift-records";
const BirReport = "/bir-report";
const CashTracking = "/cash-tracking";
const Inventory = "/inventory";
const Records = "/records";
const Path = {
  Slash: "/",
  Auth: "/auth",
  AccessAuthorization: AccessAuthorization,
  UserAccess: `${AccessAuthorization}/user-access`,
  Records: `${Records}`,
  ShiftRecords: `${Records}${ShiftRecords}`,
  ShiftDetails: `${Records}${ShiftRecords}/details`,
  ViewShiftDetails: `${Records}${ShiftRecords}/details/:id/:pageMode`,
  ViewShiftDetailsInfo: `${Records}${ShiftRecords}/details/:id/info/:pageMode`,
  ViewShiftDetailsSalesInventory: `${Records}${ShiftRecords}/details/:id/sales-inventory/:pageMode`,
  ViewShiftDetailsCashNonCash: `${Records}${ShiftRecords}/details/:id/cash/:pageMode`,
  ViewShiftDetailsInfoById: (id, pageMode) => `${Records}${ShiftRecords}/details/${id}/${pageMode}`,
  ViewShiftDetailsSalesInventoryById: (id, pageMode) =>
    `${ShiftRecords}/details/${id}/sales-inventory/${pageMode}`,
  ViewShiftDetailsCashNonCashById: (id, pageMode) =>
    `${ShiftRecords}/details/${id}/cash/${pageMode}`,
  DetailedTransactionHistory: `${Records}/detailed-transaction-history`,
  BirReport: BirReport,
  SalesSummary: `${BirReport}/sales-summary`,
  DiscountReport: `${BirReport}/discount-report`,
  SalesTransaction: `${BirReport}/sales-transaction`,
  RefundTransaction: `${BirReport}/refund-transaction`,
  VoidTransaction: `/void-transaction`,
  CashTracking: `${CashTracking}`,
  BankDeposit: `${CashTracking}/bank-deposit`,
  AddBankDeposit: `${CashTracking}/bank-deposit/add`,
  BankDepositDetails: `${CashTracking}/bank-deposit/details/:id/:pageMode`,
  ViewBankDepositDetails: (id, mode) => `${CashTracking}/bank-deposit/details/${id}/${mode}`,
  Inventory: `${Inventory}`,
  DeliveryLogs: `${Inventory}/delivery-logs`,
  AddDeliveryLog: `${Inventory}/delivery-logs/add`,
  DeliveryLogDetails: `${Inventory}/delivery-logs/details/:id/:pageMode`,
  ViewDeliveryLogDetails: (id, mode) => `${Inventory}/delivery-logs/details/${id}/${mode}`,
  Expense: `${CashTracking}/expense`,
  AddExpense: `${CashTracking}/expense/add`,
  ExpenseDetails: `${CashTracking}/expense/details/:id/:pageMode`,
  ViewExpenseDetails: (id, mode) => `${CashTracking}/expense/details/${id}/${mode}`,
  KeyAccount: `${CashTracking}/key-account`,
  AddKeyAccount: `${CashTracking}/key-account/add`,
  KeyAccountDetails: `${CashTracking}/key-account/details/:id/:pageMode`,
  ViewKeyAccountDetails: (id, mode) => `${CashTracking}/key-account/details/${id}/${mode}`,
  PurchaseOrder: `${Inventory}/purchase-order`,
  AddPurchaseOrder: `${Inventory}/purchase-order/add`,
  PurchaseOrderDetails: `${Inventory}/purchase-order/details/:id/:pageMode`,
  ViewPurchaseOrderDetails: (id, mode) => `${Inventory}/purchase-order/details/${id}/${mode}`,
};

export default Path;
